import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@cropx-common/services/api-gateway/user.state';
import {
  LocalStorageService,
  UserProps,
} from '@cropx-common/services/local-storage/LocalStorageService';
import { CommonApiService } from '@cropx-common/services/network/common-api.service';
import { GlobalPermissionService } from '@cropx-common/services/shared/GlobalPermissionService';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';

import { LoaderComponent } from '../../../../../../libs/common/src/lib/components/loader/loader.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss'],
  imports: [LoaderComponent],
})
export class ImpersonateComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);
  private globalPermissionService = inject(GlobalPermissionService);
  private store = inject(Store);
  private commonApiService = inject(CommonApiService);

  message = 'Validating credentials...';

  ngOnInit(): void {
    window.addEventListener(
      'message',
      this.handleIncomingMessages.bind(this),
      false,
    );
  }

  ngOnDestroy(): void {
    window.removeEventListener(
      'message',
      this.handleIncomingMessages.bind(this),
      false,
    );
  }

  private handleIncomingMessages(event): void {
    const adminOrigin = environment.admin_origin;
    if (event.origin !== adminOrigin) {
      return;
    }
    this.setUserProps(event).then();
  }

  private setTemporaryToken(impersonateToken) {
    const userProps: UserProps = {
      userId: 0,
      username: '',
      token: impersonateToken,
      impersonating: true,
      measurementMethod: '',
      moistureScaleMethod: '',
      clockSettingType: '',
      dateFormat: '',
    };
    this.localStorageService.setUserProps(userProps);
    this.store.dispatch(new User.SetUserSettings(userProps));
  }

  private async setUserProps(event): Promise<void> {
    const impersonateToken = `Bearer ${event.data.token}`;
    this.setTemporaryToken(impersonateToken);

    setTimeout(async () => {
      try {
        const userDefaults = await firstValueFrom(
          this.commonApiService.userApi.getUserDetails(),
        );
        this.localStorageService.clearAll();
        const userProps: UserProps = {
          userId: userDefaults.content.userId,
          username: userDefaults.content.username,
          token: impersonateToken,
          measurementMethod: userDefaults.content.measurementMethod,
          moistureScaleMethod: userDefaults.content.moistureScaleMethod,
          clockSettingType: userDefaults.content.clockSettingType,
          dateFormat: userDefaults.content.dateFormat,
          userUuid: userDefaults.content.userUuid,
        };
        this.localStorageService.setUserProps(userProps);
        this.store.dispatch(new User.SetImpersonating(true));
        this.store.dispatch(new User.SetUserSettings(userProps));
        this.globalPermissionService.userPermissionsViewModel.fetchPermissions();
        this.store
          .dispatch(new User.Login())
          .pipe(first())
          .subscribe(() => {
            this.router.navigate(['dashboard']);
          });
      } catch (e) {
        console.error(e);
      }
    }, 2000);
  }
}
